module.exports = __webpack_public_path__ + "static/media/fill_62.dce2e369.svg";